const disabledDays = [
  new Date(2024, 9, 3), // Tag der deutschen Einheit
  new Date(2024, 11, 25), // 1. Weihnachtstag
  new Date(2024, 11, 26), // 2. Weihnachtstag

  new Date(2025, 0, 1), // Neujahr
  new Date(2025, 3, 18), // Karfreitag
  new Date(2025, 3, 21), // Ostermontag
  new Date(2025, 4, 1), // Tag der Arbeit
  new Date(2025, 4, 29), // Christi Himmelfahrt
  new Date(2025, 5, 9), // Pfingstmontag
  new Date(2025, 9, 3), // Tag der deutschen Einheit
  new Date(2025, 11, 25), // // 1. Weihnachtstag
  new Date(2025, 11, 26), // 2. Weihnachtstag

  new Date(2026, 0, 1), // Neujahr
  new Date(2026, 3, 3), // Karfreitag
  new Date(2026, 3, 6), // Ostermontag
  new Date(2026, 4, 1), // Tag der Arbeit
  new Date(2026, 4, 14), // Christi Himmelfahrt
  new Date(2026, 4, 25), // Pfingstmontag
  new Date(2026, 9, 3), // Tag der deutschen Einheit
  new Date(2026, 11, 25), // // 1. Weihnachtstag
  new Date(2026, 11, 26), // 2. Weihnachtstag

  new Date(2027, 0, 1), // Neujahr
  new Date(2027, 2, 26), // Karfreitag
  new Date(2027, 2, 29), // Ostermontag
  new Date(2027, 4, 1), // Tag der Arbeit
  new Date(2027, 4, 6), // Christi Himmelfahrt
  new Date(2027, 4, 17), // Pfingstmontag
  new Date(2027, 9, 3), // Tag der deutschen Einheit
  new Date(2027, 11, 25), // // 1. Weihnachtstag
  new Date(2027, 11, 26), // 2. Weihnachtstag
  {
    // no past, not today, not tomorrow
    before: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 2),
  },
  {
    daysOfWeek: [0], // no Sunday
  },
];

export { disabledDays };
